export enum ApiPropertiesUnavailabilityReason {
	Repair = 'Repair',
	Maintenance = 'Maintenance',
	Weather = 'Weather',
	Other = 'Other',
}

export interface PropertiesBoat {
	name: string;
	callSign: string;
	imo?: string | null;
	mmsi?: string | null;
	flag: string;
	type: ApiPropertiesBoatType;
	grt: number;
	exclusionGRT?: number | null;
	deadWeight?: number | null;
	length: number;
	width: number;
	height: number;
	power: number;
	portOfRegistry: string;
	numberOfRegistry?: string | null;
	yearOfBuilding?: number | null;
	isArchived: boolean;
	isAvailable: boolean;
	unavailabilityReason?: ApiPropertiesUnavailabilityReason;
	kind: string;
	precipitationMaxValue?: number | null;
	calculatedGRT?: number | null;
	latitude: number;
	longitude: number;
	calculationObjectCode: string;
}

export enum ApiPropertiesBoatType {
	Tugboat = 'Tugboat',
	Crewboat = 'Crewboat',
	FloatingCrane = 'FloatingCrane',
	Icebreaker = 'Icebreaker',
	EnvironmentalVessel = 'EnvironmentalVessel',
	HydrographicBoat = 'HydrographicBoat',
}
